import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import './Settings.css';

const API_BASE = (process.env.REACT_APP_API_URL || "https://ukd45lve3kvj45tahklem6d67q0fbbxm.lambda-url.us-west-2.on.aws/api/chat").replace('/api/chat', '');

export default function SettingsPage() {
    const auth = useAuth();
    const navigate = useNavigate();
    const [resetting, setResetting] = useState(false);
    const [resetDone, setResetDone] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleReset = async () => {
        setResetting(true);
        try {
            const token = await auth.getIdToken();
            const headers = {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            };
            await fetch(`${API_BASE}/api/account/reset`, {
                method: "POST",
                headers,
            });
            setResetDone(true);
            setShowModal(false);
        } catch (e) {
            console.error("Reset failed", e);
        } finally {
            setResetting(false);
        }
    };

    return (
        <div className="settings-app">
            <header className="settings-topbar">
                <div className="settings-topbar-left">
                    <button className="settings-back" onClick={() => navigate('/')}>
                        <svg viewBox="0 0 24 24"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
                    </button>
                    <div className="settings-topbar-brand">Settings</div>
                </div>
                <button className="settings-topbar-signout" onClick={auth.signOut}>
                    Sign out
                </button>
            </header>

            <div className="settings-content">
                <section className="settings-section">
                    <h3 className="settings-section-label">Account</h3>
                    <div className="settings-row">
                        <span className="settings-row-label">Email</span>
                        <span className="settings-row-value">{auth?.user?.email || 'Unknown'}</span>
                    </div>
                </section>

                <section className="settings-section">
                    <h3 className="settings-section-label">Danger zone</h3>
                    <div className="settings-danger-card">
                        <div className="settings-danger-info">
                            <strong>Reset account</strong>
                            <p>Wipes coaching memory, onboarding answers, conversation history, actions, and field reports. The next time you sign in you'll be a brand new user. This cannot be undone. Your login email stays.</p>
                        </div>
                        {resetDone ? (
                            <div className="settings-reset-done">Account reset. Start fresh.</div>
                        ) : (
                            <button className="settings-btn danger" onClick={() => setShowModal(true)}>
                                Reset account
                            </button>
                        )}
                    </div>
                </section>
            </div>

            {showModal && (
                <div className="modal-backdrop" onClick={() => setShowModal(false)}>
                    <div className="modal-card" onClick={e => e.stopPropagation()}>
                        <h3>Are you sure?</h3>
                        <p>This deletes your memory, onboarding, conversations, actions, and field reports. You'll be onboarded again on the next sign-in. This cannot be undone.</p>
                        <div className="modal-actions">
                            <button className="settings-btn danger" onClick={handleReset} disabled={resetting}>
                                {resetting ? 'Resetting...' : 'Yes, delete everything'}
                            </button>
                            <button className="settings-btn cancel" onClick={() => setShowModal(false)}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
